import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["tab", "content", "filterBtn", "mealCard", "filterBar"];

  connect() {
    // Show first tab by default
    this.showTab(this.tabTargets[0]);
  }

  // Switch tabs when clicked
  switchTab(event) {
    event.preventDefault();
    const clickedTab = event.currentTarget;
    this.showTab(clickedTab);

    // Hide filter bar if custommeal-tab is selected
    const isCustomMealTab = clickedTab.id === "custommeal-tab";
    this.filterBarTarget.classList.toggle("d-none", isCustomMealTab);
  }

  // Show selected tab and hide others
  showTab(selectedTab) {
    // Handle tabs
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("active", tab === selectedTab);
    });

    // Handle content
    this.contentTargets.forEach(content => {
      content.classList.toggle(
        "d-none",
        content.id !== selectedTab.id.replace("-tab", "-tab-content")
      );
      content.classList.toggle(
        "d-flex",
        content.id === selectedTab.id.replace("-tab", "-tab-content")
      );
    });
  }

  // Filter meals based on selected category
  filterMeals(event) {
    const clickedButton = event.currentTarget;
    const selectedCategoryId = clickedButton.dataset.categoryId;

    console.log(`Filtering meals for category ID: ${selectedCategoryId}`);
    
    // Highlight the selected button and remove active class from others
    this.filterBtnTargets.forEach((btn) => {
      console.log(`Button Category ID: ${btn.dataset.categoryId}, Selected Category ID: ${selectedCategoryId}`);
      
      btn.classList.toggle("active", btn.dataset.categoryId === selectedCategoryId);
    });

    // Filter meal cards
    this.mealCardTargets.forEach((card) => {
      const cardCategoryIds = card.dataset.categoryId.split(",");
      card.classList.toggle(
        "d-none",
        selectedCategoryId !== "all" && !cardCategoryIds.includes(selectedCategoryId)
      );
    });
  }
}
